const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useDots } = window.BAO.Carousel.plugins

class YoptoReviewsCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'star', 'average', 'arrows', 'next', 'previous', 'dots']
  }

  constructor () {
    super()
    this.fetchReviews()
  }

  async fetchReviews () {
    const baseUrl = `https://api-cdn.yotpo.com/v1/widget/${window.theme.yotpo.apiKey}/products/`
    const requestUrl = `${baseUrl}${
      this.reviewType === 'product' ? this.productId : 'yotpo_site_reviews'
    }/reviews.json?per_page=30`
    const options = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }

    await fetch(requestUrl, options)
      .then(res => res.json())
      .then(json => this.renderSectionContent(json.response))
      .catch(err => this.handleError(err))
  }

  renderSectionContent (res) {
    this.renderMeta(res)
    this.renderSlides(res)
  }

  renderMeta (res) {
    this.els.average.element.innerHTML = res.bottomline.average_score.toFixed(1)
    this.renderMetaStars(res)
  }

  renderSlides (res) {
    const filteredReviews = this.filterReviews(res.reviews)
    const slidesHTML = this.slidesHTML(filteredReviews)
    const dotsHTML = this.dotHTML(filteredReviews.length - 1)

    this.els.slides.element.insertAdjacentHTML('afterbegin', slidesHTML)
    this.els.dots.element.insertAdjacentHTML('afterbegin', dotsHTML)
    this.carousel = this.setupCarousel()
    this.dataset.initialised = 'true'
  }

  filterReviews (reviews) {
    return reviews.filter(review => {
      const { sentiment, title, content } = review
      const positive = sentiment > 0.9
      const goodContent = title !== content && content.length < 100

      return positive && goodContent
    })
  }

  slidesHTML (reviews) {
    let slidesHTML = ''
    reviews.forEach(review => {
      slidesHTML += `
        <li class="sec-YotpoReviewsCarousel_Slide keen-slider__slide" data-yotpo-reviews-el="slide">
          <div class="sec-YotpoReviewsCarousel_SlideStars">${this.starsHTML(
            review.score,
          )}</div>
          ${
            review.title
              ? `<h3 class="sec-YotpoReviewsCarousel_SlideTitle fz-30_126">${review.title}</h3>`
              : ''
          }
          ${
            review.content
              ? `<p class="sec-YotpoReviewsCarousel_SlideContent fz-19_128">${review.content}</p>`
              : ''
          }
          ${
            review.user?.display_name
              ? `<h4 class="sec-YotpoReviewsCarousel_SlideDisplayName fz-16_140">${review.user.display_name}</h4>`
              : ''
          }
        </li>
      `
    })

    return slidesHTML
  }

  starsHTML (score) {
    let starsHTML = ''
    for (let i = 1; i <= 5; i++) {
      starsHTML += this.starHTML(i <= score)
    }

    return starsHTML
  }

  starHTML (full) {
    return `<span class="sec-YotpoReviewsCarousel_SlideStar" data-star="${
      full ? 'full' : 'empty'
    }" data-yotpo-reviews-banner-el="star"></span>`
  }

  renderMetaStars (res) {
    const averageRating = Number(res.bottomline.average_score.toFixed(1))
    const starEls = this.els.star.elements

    starEls.forEach((el, i) => {
      const index = i + 1

      if (index <= averageRating) {
        el.dataset.star = 'full'
      } else if (index > averageRating && index < averageRating + 1) {
        el.dataset.star = 'half'
      }
    })
  }

  dotHTML (totalReviews) {
    const dotsEl =
      '<button class="sec-YotpoReviewsCarousel_Dot" data-yotpo-reviews-carousel-el="dot" type="button"></button>'
    return dotsEl.repeat(totalReviews)
  }

  setupCarousel () {
    const dots = this.querySelectorAll('[data-yotpo-reviews-carousel-el="dot"]')

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: '[data-yotpo-reviews-el="slide"]',
        mode: 'snap',
        slides: {
          spacing: 0,
          perView: 1,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              spacing: 2,
              perView: 2,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useDots(dots),
      ],
    )
  }

  handleError (error) {
    console.error(`error:${error}`)

    if (error.toString().includes('value: -1')) {
      this.classList.add('sec-YotpoReviewsCarousel-hidden')
    }
  }

  get reviewType () {
    return this.dataset.reviewType === 'product' && this.productId
      ? 'product'
      : 'site'
  }

  get productId () {
    return this.dataset.productId
  }
}

if (!customElements.get('yotpo-reviews-carousel')) {
  customElements.define('yotpo-reviews-carousel', YoptoReviewsCarousel)
}
